import { capitalizeText } from './utils';

export const renderLeanToSelect = (option) => {
  const { object } = option;
  const mutedBackgroundColor = object?.color;
  return `
    <div class="item-gantt circle-text" >
      <span class="circle" style="background-color: ${mutedBackgroundColor}"></span>
      ${capitalizeText(object?.label)}
    </div>
  `;
};

export const renderSelectedOption = (selected, isReadOnly) => {
  const object = selected;
  const mutedBackgroundColor = object?.color;
  return `
    <div class="item-gantt item-custom-selected selected-option-container ${isReadOnly ? 'read-only' : 'clickable'}">
      <div
      class="border selected-border"
      style="color: white; background-color: ${mutedBackgroundColor}">
        <div class="text-lean" 
          style="padding-left: 5px; padding-right: 5px;"
        >
        ${object?.label}
        </div>
      </div>
    </div>
  `;
};
